import React from 'react';
import { useNavigate } from 'react-router-dom';
import "./Home.css"

const Home = () => {
  const navigate = useNavigate();
  return (
    <div className="home-container">
      <header className="home-header">
        <h1 className="brand">StockAi</h1>
        <p className="tagline">Empowering Your Stock Research & Analysis</p>
      </header>
      <section className="hero-section">
        <h2>Unlock Insights. Make Smarter Investments.</h2>
        <p>Analyze stocks, track trends, and make data-driven decisions with StockAi's powerful research tools.</p>
        <button className="cta-btn" onClick={() => navigate('/dashboard')}>Get Started</button>
      </section>
    </div>
  )
}

export default Home;